import { DataGridProvider } from '@issuemanager/apps/client/components';
import { ISSUE_TYPES_GRID_KEY } from '@issuemanager/apps/client/utils';
import { Box, Stack } from '@mui/material';
import { IssueTypesGrid } from './components/issue-types-grid';

export default function () {
  return (
    <Box px={4} py={4}>
      <Stack spacing={4} data-testid='issue-types'>
        <DataGridProvider storageKey={ISSUE_TYPES_GRID_KEY}>
          <IssueTypesGrid />
        </DataGridProvider>
      </Stack>
    </Box>
  );
}
